/**
 *
 * @param {string} value - value from input
 * @return {string} - deformatted value string
 *
 * Turn currency string into a number (still a string, gets coerced into a number as needed when the return value is used)
 */
function deformatCurrency(value) {
  return value.replace('$', '').replace(/,/g, '');
}

export default deformatCurrency;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/deformatCurrency.js